// @flow
import gql from 'graphql-tag'
import * as React from 'react'
import * as R from 'ramda'
import {Query} from 'react-apollo'
import {Helmet} from 'react-helmet'
import {translate} from 'react-i18next'
import {withRouter} from 'react-router'

export const Seo = withRouter(translate('seo')(({t, location, i18n}) =>
  <Query query={gql`{
    seo(page: "${location.pathname}", lang: "${i18n.language.substring(0, 2)}") {
      title
      description
      keywords
    }
  }`}>
    {
      ({loading, error, data}/*: any */) => {
        if (loading || error) {
          return null
        }

        const defaults = {
          lang: i18n.language.substring(0, 2),
          title: t('title'),
          description: t('description'),
          type: t('type'),
          image: t('image'),
          app: t('app'),
          robots: t('robots'),
          twitter: t('twitter'),
          www_url: `${t('www_url')}${location.pathname}`,
          intl_url: `${t('intl_url')}${location.pathname}`
        }
        const seoInfo = R.merge(data.seo, defaults)

        return (
          <Helmet>
            <title>{seoInfo.title}</title>
            <meta name='description' content={seoInfo.description} />
            <meta name='robots' content={seoInfo.robots} />
            <meta name='DC.title' lang={seoInfo.lang} content={seoInfo.title} />
            <meta name='DC.description' lang={seoInfo.lang} content={seoInfo.description} />
            <meta name='DC.subject' lang={seoInfo.lang} content={seoInfo.description} />

            {seoInfo.keywords && <meta name='keywords' content={seoInfo.keywords} />}

            {seoInfo.app && <meta name='application-name' content={seoInfo.app} />}
            {seoInfo.app && <meta name='DC.publisher' content={seoInfo.app} /> }
            {seoInfo.app && <meta property='og:site_name' content={seoInfo.app} />}

            {seoInfo.author && <meta name='DC.creator' content={seoInfo.author} />}
            {seoInfo.author && <meta name='author' content={seoInfo.author} /> }

            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:site' content={`@${seoInfo.twitter}`} />
            <meta name='twitter:title' content={seoInfo.title} />
            <meta name='twitter:description' content={seoInfo.description} />
            <meta name='twitter:image' content={seoInfo.image} />

            <meta property='og:title' content={seoInfo.title} />
            <meta property='og:description' content={seoInfo.description} />
            <meta property='og:url' content={seoInfo.intl_url} />
            <meta property='og:image' content={seoInfo.image} />
            <meta property='og:type' content={seoInfo.type} />

            <link rel='canonical' href={seoInfo.www_url} />
            <link rel='alternate' hreflang='es' href={seoInfo.www_url} />
            <link rel='alternate' hreflang='en' href={seoInfo.intl_url} />
          </Helmet>
        )
      }
    }
  </Query>
))



// WEBPACK FOOTER //
// ./src/pages/components/Seo.js